import { inject, Injectable } from '@angular/core';
import { Auth, signInWithCustomToken } from '@angular/fire/auth';
import { Functions, httpsCallable } from '@angular/fire/functions';


@Injectable({ providedIn: 'root' })
export class SsoBootstrapService {
  private auth = inject(Auth);
  private functions = inject(Functions);

  async trySsoFromHash() {
    if (!location.hash) return;

    const params = new URLSearchParams(location.hash.slice(1));
    const otcToken = params.get('otcToken');

    if (otcToken) {
      console.log("otcToken:" + otcToken);
      const state = params.get('state');
      console.log("state:" + state);
      const expectedState = sessionStorage.getItem('sso_state');
      console.log("expectedState:" + expectedState);
      sessionStorage.removeItem('sso_state');
      if (state !== expectedState) return;

      console.log('getting custom token...');
      try {

        const apiCall = httpsCallable(this.functions, 'checkOTC');
        console.log('Going to call api...')

        const { data } = await apiCall({ otcToken });

        console.log("data:" + data);
        const { customToken } = data as any;

        console.log("customToken:" + customToken);
        await signInWithCustomToken(this.auth, customToken);
      } catch (e) {
        console.error(e);
      }
      history.replaceState(null, '', location.pathname + location.search);
    }
  }
}
